/// <reference path="../../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.Nobox {

    @Serenity.Decorators.registerClass()
    export class CampaignListMenuDialog extends NoboxEntityDialog<CampaignTagsRow, CampaignListMenuOptions> {
        protected getFormKey() { return CampaignListMenuForm.formKey; }

        protected form = new CampaignListMenuForm(this.idPrefix);
        public saveCallback: (title: string) => void;
        public editCallback: (title: string) => void;
        public arrMenu: any = [];

        constructor(opt: CampaignListMenuOptions) {
            super(opt);
            this.options = opt;
        }

        updateInterface() {
            super.updateInterface();
            var opt = this.options;
            if (opt.IsEdit) {
                this.form.Section.value = opt.Section;
            }
        }

        addSubMenu() {
            if (this.validateForm()) {
                var section = this.form.Section.value;
                this.saveCallback(section);
                this.dialogClose();
            }
        }

        editSubMenu() {
            if (this.validateForm()) {
                var section = this.form.Section.value;
                this.editCallback(section);
                this.dialogClose();
            }
        }

        getToolbarButtons() {
            var buttons = [];
            buttons.push({
                title: "Save",
                onClick: () => {
                    if (this.options.IsEdit) {
                        this.editSubMenu();
                    } else {
                        this.addSubMenu();
                    }
                }
            });
            return buttons;
        }

        updateTitle() {
            this.dialogTitle = "Add Menu";
        }
    }
    class CampaignListMenuOptions {
        IsEdit?: boolean = false;
        Section?: any;
    }
}